export const MenuItems = [
    {
      title: 'JOBS BY LOCATION',
      path: '/jobDescription',
      cName: 'dropdown-link'
    },
    {
      title: 'JOBS BY SKILLS',
      path: '/SKILLS',
      cName: 'dropdown-link'
    },
    {
      title: 'JOBS BY INDUSTRY',
      path: '/INDUSTRY',
      cName: 'dropdown-link'
    },
    {
      title: 'JOBS BY COMPANY',
      path: '/COMPANY',
      cName: 'dropdown-link'
    }
  ];
  